var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59362 6.8435C4.97509 6.8435 2.00003 9.33184 2.00003 12.3906C2.00003 13.6132 2.47428 14.8558 3.344 15.8189L2.11585 17.2224C1.995 17.3606 1.96569 17.557 2.04216 17.7245C2.11816 17.892 2.28478 17.9996 2.46878 17.9996H9.06237C11.7341 17.9996 15.1872 15.699 15.1872 12.3906C15.1872 9.33184 12.2121 6.8435 8.59362 6.8435ZM5.74994 13.2497C5.23312 13.2497 4.81247 12.8291 4.81247 12.3123C4.81247 11.7955 5.23315 11.3748 5.74994 11.3748C6.26672 11.3748 6.6874 11.7955 6.6874 12.3123C6.68743 12.8291 6.26675 13.2497 5.74994 13.2497ZM8.59362 13.2497C8.07681 13.2497 7.65615 12.8291 7.65615 12.3123C7.65615 11.7955 8.07684 11.3748 8.59362 11.3748C9.1104 11.3748 9.53109 11.7955 9.53109 12.3123C9.53109 12.8291 9.11043 13.2497 8.59362 13.2497ZM11.4373 13.2497C10.9205 13.2497 10.4998 12.8291 10.4998 12.3123C10.4998 11.7955 10.9205 11.3748 11.4373 11.3748C11.9541 11.3748 12.3748 11.7955 12.3748 12.3123C12.3748 12.8291 11.9541 13.2497 11.4373 13.2497Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8866 11.5382L16.783 10.2505C17.5707 9.36159 17.9997 8.27759 17.9997 7.15612C17.9996 4.31303 15.266 2 11.9061 2C8.86778 2 6.2865 3.8934 5.83072 6.35781C6.67847 6.06975 7.62918 5.906 8.59365 5.906C12.6984 5.906 16.0709 8.77302 16.1201 12.3122H17.5309C17.9313 12.3123 18.1464 11.8408 17.8866 11.5382Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/Icon_chat.65598d5d15670a6e48b1c277693821b7.svg";
export { ForwardRef as ReactComponent };